<template>
  <div>
    <Poptip
      confirm
      class="iv-main-color iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-editor-list"
      title="你确定删除此条数据吗？"
      @on-ok="handlerOperateEvent('delete', item)">
      <span
        class="iv-main-color iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-delete-list">删除</span>
    </Poptip>
  </div>
</template>
<script>
import DeletePoptip from '@/components/poptip'
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters(['scope'])
  },
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  created () {
  },
  data () {
    return {}
  },
  components: {
    DeletePoptip
  },
  inject: {
    expandParent: {
      default () {
        return function () {}
      }
    },
    handlerOperateEvent: {
      default () {
        return function () {}
      }
    }
  },
  methods: {
    /*expand (data) {
      this.$router.push({
        path: 'dataDictionary',
        query: {
          dictTypeId: data
        }
      })
    }*/
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .ivu-poptip-popper {
    left: auto !important;
    right: 1px;
    .ivu-poptip-arrow {
      margin-left: 38px !important;
    }
    .ivu-btn {
      padding: 0px 9px !important;
    }
  }
  /deep/ .ivu-poptip-confirm {
    display: inline-flex;
  }
</style>
